export default "__VITE_ASSET__D8wCbzkE__"